<template>
  <div class="default">
    <div class="banner">
      <p>{{ $t('obsolete_banner') }}</p>
      <a href="//beautec.ca" target="_blank">{{ $t('beautec_link') }}</a>
    </div>
    <Navbar></Navbar>
    <router-view />
    <Footer></Footer>
  </div>
</template>
<style src="@/assets/css/global.less" lang="less"></style>
<style src="@/assets/css/main-flex.css"></style>

<script>
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
export default {
  components: {
    Navbar,
    Footer
  }
}
</script>
